module.exports = __webpack_public_path__ + "lemon_vue/img/click_gif.7bb4550.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/click_gif.gif
// module id = IdC8
// module chunks = 1